/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScheduleType } from '@gh/builder-shared-data';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { getDialogInput } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { ScheduleFinderDialogConfig } from '../../resources/schedule-finder-business.service';
import { getScheduleFinderListItemId } from '../../resources/schedule-finder.model';

@Injectable()
export class ScheduleFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getScheduleFinderListItemId;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    const scheduleType = getDialogInput<ScheduleFinderDialogConfig>(this.dialogData).type;

    return scheduleType === ScheduleType.Sales
      ? [
        { field: 'name', headerName: this.translationService.get('lbl_sales_folder'), width: 400 },
        { field: 'clientName', headerName: this.translationService.get('lbl_client'), width: 200 },
      ]
      : [
        // tslint:disable-next-line:max-line-length
        { field: 'jobNumber', comparator: () => 0, headerName: this.translationService.get('lbl_job_number'), width: 150 },
        { field: 'siteAddress', headerName: this.translationService.get('lbl_site_address'), width: 450 },
      ];
  }
}
